import { MatrixEvent, Room } from 'matrix-js-sdk';
import { browserNotificationService } from './browserNotificationService';
import {matrixService} from "./matrixService.ts";

interface PendingNotification {
    type: 'message' | 'join';
    roomId: string;
    roomName: string;
    event: MatrixEvent;
    senderDisplayName?: string;
    timestamp: number;
}

class NotificationBatchingService {
    private pendingNotifications: PendingNotification[] = [];

    public addMessageNotification(
        event: MatrixEvent,
        room: Room,
        senderDisplayName: string
    ): void {

        const isDirect = matrixService.isDirectMessageRoom(room)
        const roomName = !isDirect ? room.name : '';

        this.pendingNotifications.push({
            type: 'message',
            roomId: room.roomId,
            roomName,
            event,
            senderDisplayName,
            timestamp: Date.now()
        });

        browserNotificationService.showMessageNotification(event, senderDisplayName, roomName);
    }

    public addJoinNotification(
        roomId: string,
        roomName: string,
        displayName: string
    ): void {
        this.pendingNotifications.push({
            type: 'join',
            roomId,
            roomName,
            event: null as any,
            senderDisplayName: displayName,
            timestamp: Date.now()
        });

        browserNotificationService.showJoinedNotification({
            roomId,
            displayName,
            roomName
        });
    }

    public getPendingSummary(): { count: number; roomCount: number; rooms: string[]; joinCount: number; singleRoomId?: string } | null {
        if (this.pendingNotifications.length === 0) return null;

        const messageNotifs = this.pendingNotifications.filter(n => n.type === 'message');
        const joinNotifs = this.pendingNotifications.filter(n => n.type === 'join');

        const uniqueRoomIds = new Set(this.pendingNotifications.map(n => n.roomId));
        const uniqueRoomNames = [...new Map(this.pendingNotifications.map(n => [n.roomId, n.roomName])).values()];

        return {
            count: messageNotifs.length,
            joinCount: joinNotifs.length,
            roomCount: uniqueRoomIds.size,
            rooms: uniqueRoomNames,
            singleRoomId: uniqueRoomIds.size === 1 ? Array.from(uniqueRoomIds)[0] : undefined
        };
    }

    public clearPendingNotifications(): void {
        this.pendingNotifications = [];
    }
}

export const notificationBatchingService = new NotificationBatchingService();
